import React from 'react';
import { Icon, Tooltip } from 'antd';
import moment from 'moment';
import cn from 'classnames';
import Card from '../../../../../components/Card';
import { REMOVED_METER_ID } from '../../../constants/common';
import styles from './MeterCard.module.scss';

const meterStatuses = {
  Демонтирован: styles.blockContentRed,
  'Нет данных': styles.blockContentGray,
  'Не опломбирован': styles.blockContentRed,
  Опломбирован: styles.blockContentBlue,
  'Не исправен': styles.blockContentRed,
};

const Block = ({ title, content, extraContentClasses }) => {
  return (
    <div className={cn(styles.container, styles.inner)}>
      <p className={cn(styles.text, styles.title)}>{title}</p>
      <p
        className={cn(
          styles.text,
          styles.content,
          meterStatuses[content],
          extraContentClasses
        )}
      >
        {content}
      </p>
    </div>
  );
};

const AttachmentStateIcon = ({ title, typeIcon, active }) => {
  return (
    <Tooltip
      mouseLeaveDelay={0}
      title={title}
      placement="bottom"
    >
      <Icon
        type={typeIcon}
        className={cn(styles.attachmentStateIcon, {
          [styles.active]: active,
        })}
      />
    </Tooltip>
  );
};

const leftBlocks = [
  {
    title: 'Тип',
    renderContent: (meter) => meter.type.name || '-',
  },
  {
    title: 'Номер',
    renderContent: (meter) => meter.serialNumber ?? '-',
  },
  {
    title: 'Статус',
    renderContent: (meter) => meter.statusName || '-',
  },
];

const rightBlocks = [
  {
    title: 'Текущие показания',
    extraContentClasses: cn(styles.container, styles.inner),
    renderContent: (meter) =>
      !meter.lastValues?.length
        ? '-'
        : meter.lastValues.map((item) => (
            <span key={item.tariffId}>
              {item.tariffName && (
                <span
                  style={{ color: '#565758', fontSize: '14px' }}
                >{`${item.tariffName}: `}</span>
              )}
              {`${item.value ?? '-'} ${meter.type?.unit?.name ?? ''}`}
            </span>
          )),
  },
  {
    title: 'Планируемая поверка',
    renderContent: (meter) =>
      meter.nextVerificationDate
        ? moment(meter.nextVerificationDate).format('DD.MM.YYYY')
        : '-',
  },
  {
    title: 'Видимость собственнику',
    renderContent: (meter) =>
      Boolean(meter?.hasOwnProperty('showToClient')) ? (
        <Tooltip
          title={
            meter?.showToClient
              ? 'Собственник видит счётчик'
              : 'Собственник не видит счётчик'
          }
        >
          <Icon
            type={meter?.showToClient ? 'eye' : 'eye-invisible'}
            style={{ marginLeft: 2 }}
          />
        </Tooltip>
      ) : (
        '-'
      ),
  },
];

const MeterCard = ({ meter, renderActions }) => {
  return (
    <Card
      className={cn(styles.root, {
        [styles.dismantled]: meter.statusId === REMOVED_METER_ID,
      })}
    >
      <div>
        <AttachmentStateIcon
          title={meter.hasAttachment ? 'Есть вложения' : 'Вложения отсутствуют'}
          typeIcon="paper-clip"
          active={meter.hasAttachment}
        />
        <AttachmentStateIcon
          title={meter.actFileName ? 'Акт прикреплен' : 'Акт отсутствует'}
          typeIcon="file-text"
          active={meter.actFileName}
        />
      </div>
      <div className={styles.container}>
        {leftBlocks.map((block, index) => (
          <Block
            key={index}
            title={block.title}
            content={block.renderContent(meter)}
            extraContentClasses={block.extraContentClasses}
          />
        ))}
      </div>
      <div className={styles.container}>
        {rightBlocks.map((block, index) => (
          <Block
            key={index}
            title={block.title}
            content={block.renderContent(meter)}
            extraContentClasses={block.extraContentClasses}
          />
        ))}
      </div>
      {typeof renderActions === 'function' && (
        <div className={styles.actionsWrap}>{renderActions({ meter })}</div>
      )}
    </Card>
  );
};

export default MeterCard;
